import React from "react";
import PaymentMethodSelector from "../payment/PaymentMethodSelector";

const ArticleCreateStep4 = ({
  paymentMethods,
  setPaymentMethods,
  setFormpaiement,
  formPaiement,
  amount,
  prixFinal,
  setPrixFinal,
  isFree,
  validePhoneNumber,
  setValidePhoneNumber,
  onCouponChange,
  couponValue,
  setCouponValue,
  remise,
  setRemise,
  userId,        // ← ajouté
  categorieId,   // ← ajouté
}) => {
  return (
    <div className="container">
      <PaymentMethodSelector
        paymentMethods={paymentMethods}
        setPaymentMethods={setPaymentMethods}
        formPaiement={formPaiement}
        setFormpaiement={setFormpaiement}
        totalAmount={amount}
        prixFinal={prixFinal}
        setPrixFinal={setPrixFinal}
        isFree={isFree}
        validePhoneNumber={validePhoneNumber}
        setValidePhoneNumber={setValidePhoneNumber}
        onCouponChange={onCouponChange}
        couponValue={couponValue}
        setCouponValue={setCouponValue}
        remise={remise}
        setRemise={setRemise}
        userId={userId}              // ← ajouté
        categorieId={categorieId}    // ← ajouté
      />
    </div>
  );
};

export default ArticleCreateStep4;